import { useEffect, useRef, useState } from "react";
import InputB from "../../../components/InputB/InputB";
import ItemPersonDTO from "../../DTO/ItemPersonDTO";
import { Plus } from "react-feather";
import { Status } from "../day/dayView";
import Spinner from "../../../components/Spinner/Spinner";
import Person from "./Person";
import { MItem } from "../Menu";
import ItemPersonsDTO from "../../DTO/ItemPersonsDTO";
import { PersonKind } from "./PersonKind";
import { EventDTO } from "../../DTO/EventDTO";
import mainservice from "../../../services/MainService";
import ArrayManager from "../../../services/ArrayManager";
import EventList from "../Event/EventList";
import { Setter } from "../../../services/ComService";
import PlaningToolRoot from "../PlaningToolRoot";
import { InfinitScroll } from "../../../services/InfinitScroll";
import MailtoButton from "./MailtoButton";
import PersonCounter from "./PersonCounter";
import { PublishKind } from "../../models/publishKinds";
import { sessionDataSaver } from "../../../services/SessionDataSaver";
import { Help } from "../Help";
import { TagType } from "../../DTO/TagDTO";
import { ListTagFilter } from "../tags/ListTagFilter";
import { Alert, Box, Button, ButtonGroup, Stack } from "@mui/material";
import './PersonList.scss'

enum Tab {
  all,
  trainer,
}

const tabs = [
  {
    key: Tab.all,
    name: 'Alle',
  },
  {
    key: Tab.trainer,
    name: 'Trainer',
  }
]

export default function PersonList(props: {
  selected?: number,
  onSelect?: (id: number, person: ItemPersonDTO) => void,
  onSelected?: (personIds: number[]) => void,
  onTrash?: (id: number) => void,
  onRemove?: (id: number) => void,
  className?: string,
  eventId?: number,
  customerId?: number,
  customerIdOnNew?: number,
  customerLocationId?: number,
  standalone?: boolean,
  noSearch?: boolean,
  rerenderTrigger?: number,
  personKind?: PersonKind,
  propTrainerTagParent?: EventDTO,
  personTagParent?: EventDTO,
  noCount?: boolean,
  compact?: '' | 'yes' | 'medium' | 'bubble' | 'joinedEvents' | 'printList1',
  prefix?: string,
  persons?: ItemPersonDTO[],
  headline?: string,
  noMail?: boolean,
  noContentMsg?: string,
  selectAllButton?: boolean,
}) {
  const SLPlaceholder = props.standalone ? 'Standalone' : 'Local'
  const rememberNeedles = !!props.standalone
  const searchNeedlePlaceholder = `${SLPlaceholder}-personNeedle`
  const searchTagFunktionPlaceholder = `${SLPlaceholder}-personTagFunktion`
  const searchTagAbteilungPlaceholder = `${SLPlaceholder}-personTagAbteilung`
  const searchTagMarketingPlaceholder = `${SLPlaceholder}-personTagMarketing`
  const searchTagGroupInfoPlaceholder = `${SLPlaceholder}-personTagGroupInfo`
  const searchMarketingInterestsPlaceholder = `${SLPlaceholder}-personTagMarketingInterests`
  const currentPagePlaceholder = `${SLPlaceholder}-currentPage`
  const currentScrollPositionPlaceholder = `${SLPlaceholder}-currentScrollPosition`
  const oldPage = sessionDataSaver.get(currentPagePlaceholder, rememberNeedles)
  const [Needle, setNeedle] = useState(sessionDataSaver.get(searchNeedlePlaceholder, rememberNeedles))
  const [TagFunktion, setTagFunktion] = useState(sessionDataSaver.get(searchTagFunktionPlaceholder, rememberNeedles))
  const [TagAbteilung, setTagAbteilung] = useState(sessionDataSaver.get(searchTagAbteilungPlaceholder, rememberNeedles))
  const [TagMarketing, setTagMarketing] = useState(sessionDataSaver.get(searchTagMarketingPlaceholder, rememberNeedles))
  const [TagGroupInfo, setGroupInfo] = useState(sessionDataSaver.get(searchTagGroupInfoPlaceholder, rememberNeedles))
  const [TagMarketingInterests, setMarketingInterests] = useState(sessionDataSaver.get(searchTagGroupInfoPlaceholder, rememberNeedles))
  const [status, setStatus] = useState(props.persons === undefined ? Status.loading : Status.standard)
  const [Filter, setFilter] = useState(0)
  const [rerender, setRerender] = useState(0)
  const [Items] = useState(new ItemPersonsDTO({
    needle: Needle,
    getUrl: 'spt/person/list',
    trashUrl: 'spt/person/delete',
    eventId: props.eventId || -1,
    customerId: props.customerId || -1,
    customerLocationId: props.customerLocationId || -1,
    items: props.persons,
    tagIds: [TagFunktion, TagAbteilung, TagMarketing, TagGroupInfo].filter(t => t).join(';'),
    limit: props.standalone ? 20 : -1,
  }, {
    personKind: PersonKind[props.personKind || PersonKind.generic],
  }))
  const [selected] = useState(new ArrayManager())
  const [infinitScroll] = useState(new InfinitScroll({
    ref: useRef(null),
    cb: async () => {
      // What to do, if we are at the end of the list?
      const newPage = infinitScroll.incrementAndLock()
      if (newPage === -1) { return }
      setStatus(Status.loadMore)
      sessionDataSaver.set(currentPagePlaceholder, `${newPage}`)
      const newElementCount = await Items.getFromServer(newPage)
      if (newElementCount) {
        infinitScroll.unlock()
      }
      setStatus(Status.standard)
      // Now load new content - then set Status to "standard" and unlock
      // If nothing is loaded - lock permanently
    },
    saveScrollPositionCb: (scrollPosition: number) => {
      sessionDataSaver.set(currentScrollPositionPlaceholder, `${scrollPosition}`)
    },
    page: parseInt(oldPage, 10) || 0,
  }))

  const tagFilterArr: {
    kind: TagType,
    sessionPlaceholder: string,
    localSetter: (a: any) => void,
    localGetter: string,
    title: string,
    single: boolean,
  }[] = [
    {
      kind: 'FUNKTIONHOMOGEN',
      sessionPlaceholder: searchTagFunktionPlaceholder,
      localGetter: TagFunktion,
      localSetter: setTagFunktion,
      title: 'Funktion',
      single: true,
    },
    {
      kind: 'ABTEILUNGHOMOGEN',
      sessionPlaceholder: searchTagAbteilungPlaceholder,
      localGetter: TagAbteilung,
      localSetter: setTagAbteilung,
      title: 'Abteilung',
      single: true,
    },
    {
      kind: 'marketingRole',
      sessionPlaceholder: searchTagMarketingPlaceholder,
      localGetter: TagMarketing,
      localSetter: setTagMarketing,
      title: 'Rolle',
      single: true,
    },
    {
      kind: 'groupInfo',
      sessionPlaceholder: searchTagGroupInfoPlaceholder,
      localGetter: TagGroupInfo,
      localSetter: setGroupInfo,
      title: 'Gruppeninfo',
      single: true,
    },
    {
      kind: 'marketingInterests',
      sessionPlaceholder: searchMarketingInterestsPlaceholder,
      localGetter: TagMarketingInterests,
      localSetter: setMarketingInterests,
      title: 'Interessen',
      single: true,
    },
  ]

  const className = `STPersonList flex flex-column ${props.className || ''}`
  function setGlobNeedle(n: string) {
      sessionDataSaver.set(searchNeedlePlaceholder, n)
      setNeedle(n)
    }
  useEffect(() => {
    console.log('PL: want to get persons')
    if (!props.persons) {
      setStatus(Status.loading)
      const oldScrollPosition = parseInt(sessionDataSaver.get(currentScrollPositionPlaceholder)) || 0
      console.log('PL: getting persons')
      Items.getFromServer(parseInt(`-${oldPage}`) || 0).then(() => {
        setStatus(Status.standard)
        infinitScroll.scrollToPosition(oldScrollPosition)
        console.log('PL: got persons', Items.getItems())
      })
    }
  }, [props.rerenderTrigger, props.persons, Items])
  return <PlaningToolRoot standalone={props.standalone} menuItem={MItem.persons} mainContentClass={className}>
    {
      (props.standalone || props.headline) ?
      <div className='contentHeader'>
        <div>
          {
            props.headline ? <h2 className='w3-margin-right'>{props.headline}</h2> : <h1 className='w3-margin-right'>Personen</h1>
          }
          {
            !props.noCount && !props.standalone && false &&
            <PersonCounter
              items={Items.getItems()}
              parent={props.personTagParent}
              rerenderTrigger={rerender}
            />
          }
          { selected.count() > 0 &&
            <>
              <div className="w3-margin-bottom">Ausgewählt: {selected.count()}</div>
            </>
          }
        </div>
        <div
          className={`flex w3-margin-bottom`}
        >
          { !props.noCount && !props.standalone && !props.noMail &&
            <MailtoButton items={Items.getItems()} className='genericTag w3-button' />
          }
          
          <ButtonGroup>
            {
              selected.count() > 0 &&
              <Button
                variant="outlined"
                onClick={() => {
                  selected.reset()
                  setRerender(rerender + 1)
                }}
              >
                &nbsp;Auswahl aufheben
              </Button>
            }
            {
              props.selectAllButton &&
              <Button
                variant="outlined"
                onClick={() => {
                  selected.addMany(Items.getItems().map(p => p.id))
                  setRerender(rerender + 1)
                }}
              >Alle auswählen</Button>
            }
            { selected.count() > 0 &&
              <MailtoButton
                items={Items.getItems()}
                whitelist={selected.getAll() as number[] || []}
                className='genericTag w3-button'
              />
            }
            {
              selected.count() > 0 && props.onSelected &&
              <Button
                variant="contained"
                onClick={() => {
                  console.log('SELARR', selected.arr)
                  if (props.onSelected) {
                    props.onSelected((selected.arr || []).map(p => p as number))
                  }
                }}
              >
                Auswahl übernehmen
              </Button>
            }
          </ButtonGroup>
          {
            selected.count() > 0 && !props.onSelected &&
            <Box className="w3-dropdown-hover sendPersons" sx={{marginLeft: '8px'}}>
              <Button variant="contained" sx={{marginBottom: '-8px'}}>
                Teilnehmer*innen senden
              </Button>
              <div className="w3-dropdown-content w3-card context-menu w3-padding">
                <EventList
                  className='w3-margin-top'
                  selected={-1}
                  publishKind={PublishKind.isSeminar}
                  onSelect={async (id, event: EventDTO) => {
                    console.log('send ids to ', id)
                    const EventName = event.getName()
                    if (!window.confirm(`Sollen die Personen wirklich an die Veranstaltung ${EventName} gesendet werden?`)) {
                      return
                    }
                    await Setter('spt/event/addPersonsByIds', {
                      id: id,
                      personIds: selected.getAll().join(';')
                    })
                    if(window.confirm('Personen wurden an die Veranstaltung gesendet. Diese Veranstaltung jetzt aufrufen?')) {
                      window.location.href = `/view=spVeranstaltungsDetails/id=${id}/`
                    }
                  }}
                  noSearch={false}
                  compact={'yes'}
                />
              </div>
            </Box> 
          }
        </div>
        {
          !props.noSearch &&
          <Stack
            spacing={2}
            direction="row"
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: '16px'
            }}
          >
            
            <InputB
              className='flex-grow'
              returnVal={async (val) => {
                setStatus(Status.loading)
                await Items.setNeedle(val)
                setGlobNeedle(val)
                infinitScroll.reset()
                setStatus(Status.standard)
              }}
              rows={1}
              placeholder='Tippen um zu suchen oder neu anzulegen ...'
              value={Needle}
              clearButton={true}
              sendButton="Suchen"
              delay={-1}
            />
            <Help>
              <h2>Suchfunktionen im Überblick</h2>
              <div>Einfach tippen und ein paar Sekunden warten. Dann werden automatisch die passenden Ergebnisse geladen.</div>
              <h3>Sonderfunktionen:</h3>
              <ul>
                <li><strong>!</strong>: Veranstaltung - Verwende dieses Präfix, um nach einem Veranstaltungsname zu suchen</li>
                <li><strong>%</strong>: Unternehmen - Verwende dieses Präfix, um nach einem Unternehmen zu suchen</li>
                <li><strong>@</strong>: Ort - Verwende dieses Präfix, um nach einem Ort des Unternehmens zu suchen</li>
                <li><strong>&gt;</strong>: Veranstaltungsnummer - Findet nur Ergebnisse, bei denen die Veranstaltungsnummer größer ist als die eingegebenen Stellen</li>
                <li><strong>#</strong>: Telefonnummer - Findet nur Personen, bei denen diese Nummer in der Telefonnummer vorkommt. Wenn in der Telefonnummer Separatoren wie "-", " ", oder "/" vorkommen, so muss in der Nummer ein Platzhalter "%" eingetragen werden. Also z.B. "+49(0)511 - 123/456" kann man finden über "#511%123%456" oder auch "#511%456".</li>
              </ul>
            </Help>
          </Stack>
        }
        {
          Needle !== '' &&
          <button
            className='positiveButton w3-margin-bottom'
            onClick={async () => {
              if (status === Status.new) { return }
              setStatus(Status.new)
              const item = new ItemPersonDTO({
                trainer: props.personKind === PersonKind.trainer ? 1 : -1,
                customerId: props.customerIdOnNew,
              })
              console.log('new thing')
              console.log(Needle)
              await item.infoAbsorber(Needle)
              // await item.setName(Needle)
              if (props.onSelect) {
                props.onSelect(item.id, item)
              } else {
                mainservice.navTo([['view', 'spPersonEdit'], ['id', item.id]])
                /*
                setStatus(Status.loading)
                await Items.getFromServer()
                setStatus(Status.standard)
                */
              }
            }}
          ><Plus /><span className='name'>Diese Person neu anlegen</span></button>
        }
        {
          status === Status.new &&
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 4,
            }}
          >
            <Spinner />
            Lege neue Person an ...
          </Box>
        }
        <div>
          {
            props.standalone &&
            <>
              {

                tabs.map((t, index) => {
                  return <button
                    key={`plt-${index}`}
                    className={`w3-button ${Filter === t.key ? 'w3-blue' : ''}`}
                    onClick={async () => {
                      if (t.key === Tab.trainer) {
                        await Items.filterByTrainer(0)
                      } else {
                        await Items.filterByTrainer(-1)
                      }
                      setFilter(t.key)
                    }}
                  >{t.name}</button>
                })
              }
              {
                tagFilterArr.map((t, index) => {
                  return <ListTagFilter
                    key={`LilstTagFilter-${t.kind}-${index}`}
                    kind={t.kind}
                    update={async (newTags: number[]) => {
                      setStatus(Status.loading)
                      sessionDataSaver.set(t.sessionPlaceholder, newTags.join(';'))
                      t.localSetter(newTags.join(';'))
                      let tagArr = [TagFunktion, TagAbteilung, TagMarketing]
                      tagArr[index] = newTags.join(';')
                      await Items.setTagIds(tagArr.filter(t => t).join(';'))
                      infinitScroll.reset()
                      setStatus(Status.standard)
                    }}
                    title={t.title}
                    single={true}
                    selected={t.localGetter === '' ? [] : t.localGetter.split(';').map(t => parseInt(t, 10))}
                  />
                })
              }
            </>
          }
        </div>
      </div> : null
    }
    <div
      ref={infinitScroll.getRef()}
      className={`PersonList ${props.standalone ? 'scrollContent' : ''} ${props.className || ''}`}
    >
      { Items.count() > 0 && props.prefix &&
        <label className='EditFieldLabel'>
          {props.prefix}
        </label>
      }
      <div className="PersonListTable">

        {
          props.standalone &&
          <PersonHeader />
        }
        {
          Items.getItems().map((i, index) => {
            return <Person
              key={`PersonListItem-${i.id}`}
              className={`hover ${props.selected === i.id ? 'mark' : ''} `}
              item={i}
              propTrainerTagParent={props.propTrainerTagParent}
              personTagParent={props.personTagParent}
              compact={props.compact}
              onClick={props.onSelect}
              prefix={index > 0 ? ', ' : ''}
              onTrash={props.onTrash || props.standalone ? async() => {
                if (!window.confirm(`${i.firstname} ${i.lastname} ${i.email} wirklich löschen?`)) { return }
                setStatus(Status.loading)
                await Items.trashItem(i.id)
                setStatus(Status.standard)
              } : undefined}
              onRemove={props.onRemove ? () => {
                if (props.onRemove) {
                  props.onRemove(i.id)
                }
              } : undefined}
              selected={selected.has(i.id)}
              select={props.onSelect ? undefined : () => {
                console.log('PersonSelect', i.id)
                selected.toggle(i.id)
                setRerender(rerender + 1)
              }}
              cb={() => {
                setRerender(rerender + 1)
              }}
            />
          })
        }
      </div>
      {
        status === Status.loadMore &&
        <div className='textCenter'>
          <Spinner mini={true} />
          <div>Lade weitere Elemente</div>
        </div>
      }
      {
        status === Status.loading &&
        <Spinner />
      }
      {
        Items.getItems().length === 0 && status !== Status.loading &&
        <Alert severity="info">{props.noContentMsg || 'Keine Personen'}</Alert>
      }
    </div>
  </PlaningToolRoot>
}

function PersonHeader() {
  const ths = [
    {
      name: '',
      note: 'This is the Checkbox Column'
    },
    {
      name: 'Name'
    },
    {
      name: 'Firma',
      style: { paddingLeft: 0}
    },  
    {
      name: 'Funktion Homogen'
    },
    {
      name: 'Abteilung Homogen'
    },
    {
      name: 'Vertriebsinfo (Person)'
    },
    {
      name: 'Gruppeninfo'
    },
    {
      name: '',
      note: 'This is the toolbar'
    }
  ].map((t, index) => {
    const extraStyle = t.style || {}
    return <th
      key={`PersonHeader-${index}`}
      style={{
        textAlign: 'left',
        backgroundColor: '#fff',
        fontWeight: 'normal',
        padding: '8px',
        ...extraStyle,
      }}
    >{t.name}</th>
  })
  return <tr>
    {ths}
  </tr>
}
